// extracted by mini-css-extract-plugin
export default {"wrapper":"feedcontent_wrapper__9zCLo","wrapper2":"feedcontent_wrapper2__hh-vu","home_feed":"feedcontent_home_feed__aywbE","sidebar":"feedcontent_sidebar__O81ww"};